<div>
    <div style="padding: 10px;" class="row" *ngIf="is_speaker_active==true || is_dining_active==true">
        <div class="col-md-5 col-sm-12">
            <h6 class="font pull-left text-black"> <span class="back" (click)="back()"> <i class="fas fa-arrow-left"> </i>
                    &nbsp;
                    Back</span></h6>
        </div>
    </div>
</div>
<div style="z-index: -999999;" class="modal-body">
    <div id="top-image" class="row">
        <!-- <div class="col-lg-4 col-md-4 col-sm-4 col-4 "
            [ngClass]="(is_dining_active==true || is_speaker_active==true)?'mt-40':''"><img
                class="float-left mt--5 mt-5 ml-5-0" src="../../../../assets/img/org-logo.svg" alt=""></div> -->
        <!-- <div class="col-lg-4 col-md-4 col-sm-4 col-4 "
            [ngClass]="(is_dining_active==true || is_speaker_active==true)?'mt-40':''"><img
                class="float-left orf" src="../../../../assets/img/ORF-Logo.png" alt=""></div> -->
        <div class="col-12 display-flex" ><img
                [ngClass]="(is_dining_active==true || is_speaker_active==true)?'':'mtt-20'" class="float-right raisina-logo"
                src="../../../../assets/img/raisina2024.png" alt=""></div>
        <!-- <div class="col-lg-4 col-md-4 col-sm-4 col-4 "
            [ngClass]="(is_dining_active==true || is_speaker_active==true)?'mt-30':'mtt-10'"><img
                class="float-right mt--5 mr-5-0" src="../../../../assets/img/MOE.svg" alt=""></div> -->
        <!-- <div class="col-lg-4 col-md-4 col-sm-4 col-4 "
            [ngClass]="(is_dining_active==true || is_speaker_active==true)?'mt-30':'mtt-10'"><img
                class="float-right moe" src="../../../../assets/img/MOE.png" alt=""></div> -->
    </div>
    <div id="middle-image" class="row">
        <div class=" col-lg-3 col-md-3 col-sm-3 col-3"></div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 display-flex"><img class="float-right my-15 "
                src="../../../../assets/img/Raisina_Caption.png" alt="">
        </div>
        <div class=" col-lg-3 col-md-3 col-sm-3 col-3"></div>
    </div>
</div>
<div class=" my-15">
    <!-- mt-3 -->
        <div *ngIf="this.user_name!=''" class="title-head color-black font">Welcome {{this.user_name}}</div>
</div>
<div class="" *ngIf="this.user_name!='' && is_agenda_active==false && this.length!=0">
    <div class="sect">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 display-flex ">
                <div class="row font">
                    <div *ngIf="this.userDetails.user_role==1"
                        class=" col-lg-12 col-md-12 col-sm-12 col-12 p-2 display-flex" (click)="getContent(1)"><button
                            class="btn btn-event">Speaking Engagement</button></div>
                    <div class=" col-lg-12 col-md-12 col-sm-12 col-12 p-2 display-flex" (click)="getContent(2)"><button
                            class="btn btn-event">Dining Invite</button></div>
                    <div class=" col-lg-12 col-md-12 col-sm-12 col-12 p-2 display-flex"> <a class="color-white"
                            href="https://www.orfonline.org/forums/raisina-dialogue/agenda" target="_blank"><button
                                class="btn btn-event">Conference Agenda</button></a></div>
                    <div class=" col-lg-12 col-md-12 col-sm-12 col-12 p-2 display-flex"><a class="color-white"
                            href="https://www.orfonline.org/about-us/" target="_blank"><button class="btn btn-event">About
                                Us</button></a></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-body content" *ngIf="(is_dining_active==true || is_speaker_active==true)">
    <div *ngIf="userDetails.user_role==1 && is_speaker_active==true" id="speanking" class="sect font">
        <div class="title-head"> Speaking Engagement</div>
        <div class="row display-flex">
            <div class="title-head day">Day {{this.userDetails.day}} - {{this.userDetails.day_1_date}}</div>
            <div  class="col-md-12 col-sm-12 title-head blue-color"
                [innerHtml]="this.userDetails.speaking_engagement"></div>
        </div>
        <div class="row display-flex " *ngIf="this.userDetails2.speaking_engagement">
            <div class="title-head day">Day {{this.userDetails2.day}} - {{this.userDetails2.day_1_date}}</div>
            <div  class="col-md-12 col-sm-12 title-head blue-color"
                [innerHtml]="this.userDetails2.speaking_engagement"></div>
        </div>
        <div class="row display-flex " *ngIf="this.userDetails3.speaking_engagement">
            <div class="title-head day">Day {{this.userDetails3.day}} - {{this.userDetails3.day_1_date}}</div>
            <div  class="col-md-12 col-sm-12 title-head blue-color"
                [innerHtml]="this.userDetails3.speaking_engagement"></div>
        </div>
    </div>

    <div *ngIf="is_dining_active==true" class="sect" id="dining font">
        <div class="title-head"> Dining Invite</div>
        <div class="row display-flex">
            <div class="title-head day">Day {{this.userDetails.day}} - {{this.userDetails.day_1_date}}</div>
            <div  class="col-md-12 col-sm-12 title-head blue-color"
                [innerHtml]="this.userDetails.dinning"></div>
        </div>
        <div class="row display-flex" *ngIf="this.userDetails2.dinning">
            <div class="title-head day">Day {{this.userDetails2.day}} - {{this.userDetails2.day_1_date}}</div>
            <div  class="col-md-12 col-sm-12 title-head blue-color"
                [innerHtml]="this.userDetails2.dinning"></div>
        </div>
        <div class="row display-flex" *ngIf="this.userDetails3.dinning">
            <div class="title-head day">Day {{this.userDetails3.day}} - {{this.userDetails3.day_1_date}}</div>
            <div  class="col-md-12 col-sm-12 title-head blue-color"
                [innerHtml]="this.userDetails3.dinning"></div>
        </div>
    </div>
</div>
<div class="modal-body content mt-3 font" *ngIf="this.user_name=='' || this.length==0 ">
    <div id="speanking" class="sect">
        <div class="title-head">Coming Soon.</div>
    </div>
</div>
